import { Alert, Button, Flex, Typography } from 'antd';
import type { ReactNode } from 'react';

export function PageShell({
  title,
  description,
  action,
  error,
  children,
}: {
  title: string;
  description: string;
  action?: ReactNode | undefined;
  error?: Error | undefined;
  children: ReactNode;
}) {
  return (
    <section className="page-shell">
      <Flex justify="space-between" align="start" gap={24} wrap>
        <div>
          <Typography.Title level={2}>{title}</Typography.Title>
          <Typography.Paragraph type="secondary">
            {description}
          </Typography.Paragraph>
        </div>
        {action}
      </Flex>
      {error ? (
        <Alert
          type="error"
          showIcon
          message={error.message}
          className="page-alert"
        />
      ) : null}
      {children}
    </section>
  );
}

export function RefreshButton({
  loading,
  onClick,
}: {
  loading: boolean;
  onClick: () => void;
}) {
  return (
    <Button loading={loading} onClick={onClick}>
      Refresh
    </Button>
  );
}
